import React from 'react'
import { WifiIcon } from "../../../../styles/img/svg/WifiIcon";
import { ShowerIcon } from "../../../../styles/img/svg/ShowerIcon";
import { BreakfastIcon } from "../../../../styles/img/svg/BreakfastIcon";
import { KingBedIcon } from "../../../../styles/img/svg/KingBedIcon";
import { SizeIcon } from "../../../../styles/img/svg/SizeIcon";

export function UiCourseFeatureWr(props) {
    return (
        <>
            <div className='sb-course-features' {...props} />
        </>
    )
}

export function UiCourseFeatureIcon(props) {
    return (
        <>
            <div className='sb-course-features__icon' {...props} />
        </>
    )
}

export function UiCourseFeatureText(props) {
    return (
        <>
            <div className='sb-course-features__text'>
                <span>{props.text}</span>
            </div>
        </>
    )
}
export function UiCourseFeaturePointBox(props) {
    return (
        <>
            <div className='sb-course-features-point-box'>
                <h3>1234</h3>
                <span>Points</span>
            </div>
        </>
    )
}

export function UiCourseContentFeatures(props) {
    return (
        <>
            <div className='sb-course-content-features'>
            {props.wifi &&
            <div><WifiIcon />Wi-fi</div>
            }
            {props.bathup &&
            <div><ShowerIcon />Bathup</div>
            }
            {props.breakfast &&
            <div><BreakfastIcon />Breakfast</div>
            }
            {props.kingbed &&
            <div><KingBedIcon />King bed</div>
            }
            {props.size && 
            <div><SizeIcon />4m x 6m</div>
            }
            </div>
        </>
    )
}